import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { ImisApiService } from './services/imis-api.service';
import { ChatbotService } from './services/chatbot.service';
import { AccessControlInterceptor } from './core/interceptors/access-control.interceptor';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [
    ImisApiService,
    ChatbotService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AccessControlInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
